module.exports = __webpack_public_path__ + "static/media/linkedin.43eff0ac.svg";